import { PortalAuthCard } from "@/features/portal/components/auth/portal-auth-card";

/** `/portal/:portalName` (+ `/auth`) — resolve the firm portal + run the auth
 * phase machine (login / signup / forgot / 2FA / set-password / select). */
export default function PortalEntryPage() {
  return <PortalAuthCard />;
}
